import { render } from "./ExtraMessage.vue?vue&type=template&id=25e4cde9&scoped=true"
import script from "./ExtraMessage.vue?vue&type=script&lang=js"
export * from "./ExtraMessage.vue?vue&type=script&lang=js"

import "./ExtraMessage.vue?vue&type=style&index=0&id=25e4cde9&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e4cde9"]])

export default __exports__